import { useCallback, useMemo, useState } from "react";

interface UseShowMoreLessOptions<T> {
	items: T[];
	threshold?: number;
}

interface UseShowMoreLessReturn<T> {
	isExpanded: boolean;
	toggle: () => void;
	itemsToDisplay: T[];
	shouldShowToggle: boolean;
}

export const useShowMoreLess = <T>({ items, threshold = 2 }: UseShowMoreLessOptions<T>): UseShowMoreLessReturn<T> => {
	const [isExpanded, setIsExpanded] = useState(false);

	const shouldShowToggle = useMemo(() => items.length > threshold, [items.length, threshold]);

	const itemsToDisplay = useMemo(() => {
		if (isExpanded || items.length <= threshold) {
			return items;
		}
		return items.slice(0, threshold);
	}, [isExpanded, items, threshold]);

	const toggle = useCallback(() => {
		setIsExpanded((prev) => !prev);
	}, []);

	return {
		isExpanded,
		toggle,
		itemsToDisplay,
		shouldShowToggle,
	};
};
